import { Text } from '@/components/shared/element/text';
import { Flex } from '@/components/shared/layout/flex';
import { Section } from '@/components/shared/layout/section';
import { Image } from '@/components/shared/media/image';
import { generateCommonImageSources } from '@/components/shared/media/image/generate-sources';

interface MaintenanceTableDefaultPlaceholderProps {
  imageMobile: string;
  imageDesktop: string;
  placeholder: string;
  isVisible: boolean;
}

export const MaintenanceTableDefaultPlaceholder = (
  props: MaintenanceTableDefaultPlaceholderProps
) => {
  return (
    <Section
      test="section_maintenance_default"
      css={{
        display: props.isVisible ? 'block' : 'none',
      }}
    >
      <Image
        priority
        src={props.imageDesktop}
        alt="Maintenance List"
        aspectRatio={{ '@initial': '1by1', '@lg': '21by9' }}
        width={1280}
        height={549}
        sources={generateCommonImageSources({
          mobileSrc: props.imageMobile,
          mobileOptions: {
            quality: 65,
          },
          desktopSrc: props.imageDesktop,
          desktopOptions: {
            quality: 65,
          },
        })}
        layout="responsive"
      />
      <Flex
        alignItems="center"
        justifyContent="center"
        css={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          zIndex: '1',
          textAlign: 'center',
        }}
      >
        <Text
          as="p"
          size="h2"
          variant="text-white"
          wrap
          dangerouslySetInnerHTML={{ __html: props.placeholder }}
        />
      </Flex>
    </Section>
  );
};
MaintenanceTableDefaultPlaceholder.displayName =
  'SectionServiceMaintenanceTableDefaultPlaceholder';
